import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom' // ใช้ Link จาก react-router-dom
import Submenu from './Submenu'
import '../assets/css/main.css'

const Navbar = ({ language, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [activeLink, setActiveLink] = useState('')

  const submenuRef = useRef(null)
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)

  const navigate = useNavigate()

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen)
  }

  const handleNavigation = (e, screen, isSubmenu = false) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault(); 
    }
    if (screen.startsWith('projects/')) {
      setActiveLink('projects');
    } else {
      setActiveLink(screen);
    }
    if (!isSubmenu) {
      setIsOpen(false); 
    }
    setIsSubmenuOpen(isSubmenu); 
    navigate(`/${screen}`);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setTimeout(() => {
          setIsSubmenuOpen(false)
        }, 500) // เพิ่มหน่วงเวลา 100ms
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <nav className='navbar'>
      <div className='flex justify-between items-center w-2/4 logo-sec'>
        <Link to='/home' onClick={e => handleNavigation(e, 'home')}>
          <img
            src={require('../assets/images/logo.png')}
            alt='Logo'
            className='logo'
          />
        </Link>
      </div>

      <button className='hamburger md:hidden' onClick={toggleMenu}>
        &#9776;
      </button>

      <ul className={`nav-links ${isOpen ? 'open' : 'close'}`}>
        <li>
          <Link
            to='/home'
            onClick={e => handleNavigation(e, 'home')}
            className={activeLink === 'home' ? 'active' : ''}
          >
            {language === 'en' ? 'HOME' : 'หน้าแรก'}
          </Link>
        </li>
        <li
          className={`menu-item ${isSubmenuOpen ? 'open' : ''}`}
          ref={submenuRef}
        >
          <button
            className={'p-1.5'}
            onClick={e => toggleSubmenu(e)}
            onFocus={() => {
              setIsSubmenuOpen(true)
            }}
            onMouseDown={e => {
              e.preventDefault()
            }}
            onBlur={() => {
              setTimeout(() => {
                setIsSubmenuOpen(false)
              }, 100)
            }}
          >
            {language === 'en' ? 'PROJECTS' : 'โครงการ'}
          </button>
          {isSubmenuOpen && (
            <Submenu language={language} onNavigate={handleNavigation} />
          )}
        </li>

        <li>
          <Link
            to='/contact'
            onClick={e => handleNavigation(e, 'contact')}
            className={activeLink === 'contact' ? 'active' : ''}
          >
            {language === 'en' ? 'CONTACT' : 'ติดต่อ'}
          </Link>
        </li>
      </ul>

      <div className='language-selector flex flex-col md:flex-row items-center md:hidden'>
        <span
          className={`cursor-pointer ${language === 'en' ? 'selected' : ''}`}
          onClick={() => onLanguageChange('en')}
        >
          EN
        </span>
        <span className='mx-1'>|</span>
        <span
          className={`cursor-pointer ${language === 'th' ? 'selected' : ''}`}
          onClick={() => onLanguageChange('th')}
        >
          TH
        </span>
      </div>
    </nav>
  )
}

export default Navbar
